import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import TransactionTypeTag from '../../common/transactionTypeTag/TransactionTypeTag';
import SignedAmount from '../../common/signedAmount/SignedAmount';
import { toneForLedgerRow } from '../../../utils/money';
import { formatLedgerDate } from '../../../utils/dates';
import styles from '../styles/ticket-linked-ledger.module.scss';

/**
 * Single linked ledger transaction on a support ticket detail page.
 *
 * The date and the amount follow the ledger's own rules (`utils/dates`,
 * `utils/money`), so a transaction reads here exactly as it does on the Reports
 * tab and the User page: the date in the ledger zone rather than the viewer's,
 * a settlement green and an advance neutral.
 *
 * Known limitation: the support-ticket ledger shape (`mapLedgerRow` in
 * clockout-service `controllers/admin/supportticket.controller.js`) carries
 * only `{ id, clientId, type, amount, createdAt }` — no `is_reconciliation` —
 * so on a ticket a reconciliation settlement renders green like a real
 * repayment. Closing that needs the service to emit the flag; until then this
 * view only has the type to go on.
 *
 * @param {Object} props
 * @param {{ id: string, type: string, amount: number, createdAt: string }} props.ledger
 */
function TicketLinkedLedger({ ledger }) {
    return (
        <div className={styles.item}>
            <TransactionTypeTag type={ledger.type} />
            <Text as="span" size="s" className={styles.date}>
                {formatLedgerDate(ledger.createdAt)}
            </Text>
            <SignedAmount amount={ledger.amount} tone={toneForLedgerRow(ledger)} />
        </div>
    );
}

export default TicketLinkedLedger;
